var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramSticky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.976553 5.7786C2.5111 4.9333 4.22406 4.2278 5.82457 3.51877C8.5781 2.35736 11.3425 1.21608 14.1348 0.153558C14.6781 -0.0274723 15.6543 -0.204493 15.75 0.600597C15.6976 1.74024 15.482 2.87321 15.3341 4.0062C14.9587 6.4977 14.5249 8.9807 14.1018 11.464C13.956 12.2911 12.9198 12.7193 12.2568 12.19C10.6634 11.1137 9.0577 10.0479 7.4847 8.9466C6.9694 8.423 7.4472 7.6711 7.9074 7.2972C9.2198 6.0039 10.6116 4.905 11.8554 3.54486C12.1909 2.7347 11.1996 3.41748 10.8726 3.6267C9.0759 4.8648 7.3233 6.1785 5.42903 7.2666C4.46146 7.7992 3.33374 7.3441 2.36661 7.0469C1.49948 6.6878 0.228773 6.3261 0.976463 5.7787L0.976553 5.7786Z",
    fill: "#14161E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramSticky);
export default __webpack_public_path__ + "static/media/telegramSticky.718ac6fc7cac21201d8cc845380678e3.svg";
export { ForwardRef as ReactComponent };